export const API_URL = import.meta.env.VITE_BACKEND_URL + "/api";
export const STRIPE_WEBHOOK_URL =
  import.meta.env.VITE_BACKEND_URL + "/api/webhooks/stripe";
  